<template>
  <div class="questionnaire-paper">
    <div class="questionnaire-back"></div>
    <div class="questionnaire-main" v-if="dataDone">
      <referral :form-data="formData" />
      <div class="back"><button v-if="controlType" class="back-button" @click="reset">确认转诊单</button>
        <button v-else class="back-button" @click="back">返回</button>
      </div>
    </div>
    <x-dialog v-if="finishShow" title="确认转诊医生" @close="finishShow = false">
      <div class="finish-content">
        <div class="text">是否确认当前选择的医生</div>
        <div class="control">
          <button @click="finishShow = false" class="cancel">取消</button>
          <button @click="resetConfirm" class="confirm">确定</button>
        </div>
      </div>
    </x-dialog>
  </div>

</template>

<style lang="less" scoped>
  .questionnaire-paper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    .questionnaire-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: #00848A;;
      z-index: 1;
    }
    .questionnaire-main{
      position: relative;
      z-index: 10;
      padding: 4px 8px 0;
      .back{
        margin: 24px 0 12px;
        .back-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import referral from '@/components/Common/referral'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        formData: {},
        controlType: false,
        finishShow: false

      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      referral,
      xDialog
    },
    created() {

      this.$root.post('/ReferDetail', {
        refer_id: this.$route.params.id
      }).then(data => {
            console.log('data')
        console.log(data)
        this.dataDone = true;
        this.formData = data;
        if (data.ori_docid == this.userInfo.user_id) {
          //当前身份原始医生，不能操作
          this.controlType = false
        } else if (this.formData.refer_docid > 0) {
          this.controlType = false
        } else {
          this.controlType = true;
        }

      })
    },
    methods: {
      back() {
        //this.$router.go(-1);
        if(this.userInfo.role==1){
          this.$router.push({
            path: '/doctor/consulting-room'
          });
        }else{
          this.$router.push({
            path: '/patient/chat-room'
          });
        }
 
      },
      resetConfirm() {
        let _this = this;

        if (this.formData.refer_docid == 0) {
          this.formData.refer_docid = this.formData.recom_docid;
        }
        this.$root.post('/ResetReffer', {
          reffer_id: this.formData.reffer_id,
          refer_docid: this.formData.refer_docid
        }).then(data => {
          if (data.status == 1) {
            // 发送自定义的处方卡片
            let conversationType = RongIMLib.ConversationType.PRIVATE;
            let targetId = this.formData.refer_docid.toString();
            console.log(targetId)
            console.log(this.formData)
     
            let msg = new RongIMClient.RegisterMessage.ReferMessage({
              username: this.formData.pat.pat_username,
              reason: this.formData.referral_reason,
              create_time: data.create_time,
              birthday: this.formData.pat.birthday,
              gender: this.formData.pat.gender,
              id: this.formData.reffer_id,
            })
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
              onSuccess: function(message) {
                _this.$notify({
                  background: '#00848A',
                  message: '转诊信息发送成功'
                });


                _this.$router.push({
                  path: '/patient/chat-room'
                });
              },
              onError: function(errorCode) {
                console.log('发送自定义消息失败', errorCode);
              }
            })
          
          } else {
            this.$notify(data.msg);
          }

        })

      },
      reset() {
        this.finishShow = true;


      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/referralPaper.vue